import withRouter from "common/with-router";
import React, { ReactElement, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "slices/hook";
import { getLayoutState } from "slices/layouts/reducer";
import { AppDispatch } from "slices/store";
import { changeLayoutMode } from "slices/thunk";

interface Props {
  children: ReactElement;
}

const NonAuthLayout: React.FC<Props> = (props: Props) => {
  const dispatch: AppDispatch = useAppDispatch();
  const { layoutModeType, layoutTopbarColorType, layoutSemiDarkType } = useAppSelector(getLayoutState);

  /* const dispatch = useDispatch<any>();

   const selectProperties = createSelector(
    (state: RootState) => state.layout,
    (layout) => ({
      layoutModeType: layout.layoutModeType,
    })
  );
  const { layoutModeType } = useSelector(selectProperties);
  */

  useEffect(() => {
    if (layoutModeType) {
      // dispatch(changeLayoutMode(layoutModeType));
    }
  }, [layoutModeType]);
  useEffect(() => {
    document.documentElement.classList.add("light", "scroll-smooth", "group");
    return () => {
      document.documentElement.classList.remove("light", "scroll-smooth", "group");
    };
  }, []);

  return <React.Fragment>{props.children}</React.Fragment>;
};

export default withRouter(NonAuthLayout);
